(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-partner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function showSuccess(form) {
      form.dataset.cmPartnerSent = '1';
      form.querySelector('[data-cm-partner-fields]').hidden = true;
      form.querySelector('[data-cm-partner-intro]').hidden = true;
      form.querySelector('[data-cm-partner-error]').hidden = true;
      var success = form.querySelector('[data-cm-partner-success]');
      success.hidden = false;
      success.focus();
    }

    function buildPayload(form) {
      var values = {}, order = [];
      form.querySelectorAll('input,select,textarea').forEach(function (input) {
        var name = input.name || '';
        if (name.indexOf('contact[') !== 0 || name === 'contact[Company website confirm]') return;
        if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
        var value = String(input.value || '').trim();
        if (!value) return;
        var key = name.slice(8).replace(/\]$/, '');
        if (values[key]) values[key] += ', ' + value;
        else { values[key] = value; order.push(key); }
      });
      var name = values.name || '', space = name.indexOf(' ');
      var first = space > 0 ? name.slice(0, space) : name;
      var last = space > 0 ? name.slice(space + 1) : '';
      var message = ['Submitted from ' + location.pathname + ' on chaosmoto.com'];
      order.forEach(function (key) {
        if (['email', 'name', 'phone', 'business_name', 'company'].indexOf(key.toLowerCase()) < 0) {
          message.push(key.replace(/_/g, ' ') + ': ' + values[key]);
        }
      });
      var fields = [
        { name: 'email', value: values.email },
        { name: 'firstname', value: first },
        { name: 'company', value: values.business_name },
        { name: 'message', value: message.join('\n') }
      ];
      if (last) fields.push({ name: 'lastname', value: last });
      if (values.phone) fields.push({ name: 'phone', value: values.phone });
      var context = { pageUri: location.href, pageName: document.title };
      var cookie = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
      if (cookie) {
        try { context.hutk = decodeURIComponent(cookie[1]); } catch (error) {}
      }
      return { fields: fields, context: context };
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches('form.cm-partner')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.cmPartnerPending === '1' || form.dataset.cmPartnerSent === '1') return;
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var decoy = form.querySelector('[name="contact[Company website confirm]"]');
      if (decoy && decoy.value.trim()) { showSuccess(form); return; }
      var button = form.querySelector('button[type="submit"]');
      var label = button.textContent;
      var errorBox = form.querySelector('[data-cm-partner-error]');
      errorBox.hidden = true;
      form.dataset.cmPartnerPending = '1';
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = button.dataset.sending;
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      fetch('https://api.hsforms.com/submissions/v3/integration/submit/247031564/9db894e6-329f-4d2b-8006-7518d7aab39d', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildPayload(form)),
        signal: controller.signal
      }).then(function (response) {
        if (!response.ok) {
          var rejected = new Error('rejected');
          rejected.deliveryRejected = true;
          throw rejected;
        }
        showSuccess(form);
      }).catch(function (error) {
        errorBox.textContent = error.deliveryRejected ? errorBox.dataset.rejected : errorBox.dataset.unconfirmed;
        errorBox.hidden = false;
        errorBox.focus();
      }).finally(function () {
        clearTimeout(timeout);
        form.dataset.cmPartnerPending = '0';
        form.removeAttribute('aria-busy');
        if (form.dataset.cmPartnerSent !== '1') {
          button.disabled = false;
          button.textContent = label;
        }
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
